import React from "react";
import Hero from "./Hero";
import IntroductionText from "./Components/IntroductionText";
import SelectedWork from "./Components/SelectedWork";
import GithubCalander from "./Components/GithubCalander";
import OtherWork from "./Components/OtherWork";

export default function Home() {
    return (
        <div className="flex flex-col md:gap-6">
            <Hero />
            <div className="p-3">
                <IntroductionText />
                <SelectedWork />
                <OtherWork />
            </div>
        </div>
    );
}
